// extracted by mini-css-extract-plugin
export default {"wrapper":"MatrixStackedBars_wrapper__6jp6j","border":"MatrixStackedBars_border__AvdNX"};